const _ = require("lodash");

import Vue from "vue";
import Vuex from "vuex";
import Joi from "joi";

import API from "../api";

function validator(data, schema) {
	const { error } = Joi.validate(data, schema, {
		allowUnknown: true,
	});
	if (error) return false;
	return true;
}

Vue.use(Vuex);

async function HandleError(callback) {
	try {
		return await callback();
	} catch (e) {
		throw e.response.data;
	}
}
const StoryModule = {
	namespaced: true,
	state: {
		storyList: {
			// 故事清單（pagination）
			total: 0,
			list: [],
		},
		createStories: [], //創立故事用
		passwordStories: [], //初次設定密碼用
		editStoryData: {}, //編輯中之故事
	},
	mutations: {
		addNewCreateStories(state, data) {
			state.createStories.push(data);
		},
		setCreateStory(state, data) {
			let i = _.findIndex(state.createStories, { index: data.index });
			state.createStories[i] = _.cloneDeep(data);
		},
		cleanCreateStories(state) {
			state.createStories = [];
		},
		cleanEditStoryData(state) {
			state.editStoryData = {};
		},
		cleanStoryList(state) {
			state.storyList = [];
		},
		cleanStoryList(state) {
			state.storyList = {};
		},
		cleanPasswordStories(state) {
			state.passwordStories = [];
		},
		deleteCreateStory(state, index) {
			_.remove(state.createStories, (story) => {
				return story.index == index;
			});
			state.createStories = _.cloneDeep(state.createStories);
		},
		setStoryList(state, data) {
			state.storyList = _.cloneDeep(data);
		},
		setPasswordStories(state, data) {
			state.passwordStories = _.cloneDeep(data);
		},
		updatePasswordStoryPassword(state, data) {
			let i = _.findIndex(state.passwordStories, { id: data.id });
			state.passwordStories[i].password = data.password;
		},
		setEditStoryData(state, data) {
			state.editStoryData = _.cloneDeep(data);
		},
		updateEditStoryData(state, data) {
			state.editStoryData = _.cloneDeep(_.assign(state.editStoryData, data));
		},
		updateQuestionnaireStatus(state, data) {
			Vue.set(state.editStoryData, "questionnaireStatus", data);
		},
	},
	actions: {
		async applyStory({ commit }, data) {
			return await HandleError(async () => {
				let res = await API.ApplyStory(data);
				let applyData = {
					apply_status: res.data.apply_status,
				};
				commit("updateEditStoryData", applyData);
				return res;
			});
		},
		async searchAccount({}, data) {
			return await HandleError(async () => {
				let res = await API.SearchAccount(data);
				return res;
			});
		},
		async createStory({ state, commit }) {
			let createStories = [...state.createStories];
			for (let story of createStories) {
				delete story["index"];
				for (let member of story.team_members) {
					delete member["index"];
				}
				for (let counselor of story.counselors) {
					delete counselor["index"];
				}
			}
			await HandleError(async () => {
				let res = await API.CreateStory(createStories);
				commit("setPasswordStories", res.data);
				return true;
			});
		},
		async getPersonStoryList({ commit }, data) {
			await HandleError(async () => {
				let res = await API.GetPersonStoryList(data);
				commit("setStoryList", res.data);
			});
		},
		async updateStory({ dispatch }, data) {
			await HandleError(async () => {
				await API.UpdateStory(data);
			});
		},
		async deleteStory({ commit }, id) {
			await HandleError(async () => {
				await API.DeleteStory(id);
			});
		},
		async fetchEditStory({ commit }, id) {
			await HandleError(async () => {
				let res = await API.GetSingleStory(id);
				commit("setEditStoryData", res.data);
			});
		},
		async getStoriesStatus({ commit }) {
			return await HandleError(async () => {
				let res = await API.GetStoriesStatus();
				return res;
			});
		},
		async getQuestionnaireStatus({ commit, state }) {
			let editStory = state.editStoryData;
			let data = {
				form_type: editStory.form_type,
				id_list: [],
			};
			for (let counselor of editStory.counselors) {
				data.id_list.push(counselor.id);
			}
			for (let member of editStory.team_members) {
				if (member.id) {
					data.id_list.push(member.id);
				}
			}
			await HandleError(async () => {
				let res = await API.GetQuestionnaireStatus(data);
				commit("updateQuestionnaireStatus", res.data);
			});
		},
		checkProgress({ state }) {
			const data = state.editStoryData;
			let progress = data.progress;
			/**
			 * 0: 填寫小組成員資訊
			 * 1: 加入其他輔導員夥伴
			 * 2: 感受
			 * 3: 照片
			 * 4: 學習單
			 * 5: 創用CC授權書
			 * 6: 影片
			 * 7: SDGs
			 * 8: 國際證書
			 * 9: 輔導員問卷
			 * 10: DFC Taiwan 審核
			 */
			progress.message = "資料填寫完成";
			// 感受
			let problemVal = validator(data.problem, Joi.string().required());
			if (problemVal) {
				progress.bar_list[2] = true;
			} else {
				progress.bar_list[2] = false;
				progress.message = "2.1「感受到的問題」尚未完成";
				return progress;
			}

			// 上傳故事資料 - 圖片
			let picturesVal = validator(
				data.pictures,
				Joi.object({
					feeling: Joi.array()
						.items(
							Joi.object({
								is_cover: Joi.boolean().required(),
								url: Joi.string().required(),
								description: Joi.string().required(),
							})
						)
						.required(),
					imagine: Joi.array()
						.items(
							Joi.object({
								is_cover: Joi.boolean().required(),
								url: Joi.string().required(),
								description: Joi.string().required(),
							})
						)
						.required(),
					implement: Joi.array()
						.items(
							Joi.object({
								is_cover: Joi.boolean().required(),
								url: Joi.string().required(),
								description: Joi.string().required(),
							})
						)
						.required(),
					share: Joi.array()
						.items(
							Joi.object({
								is_cover: Joi.boolean().required(),
								url: Joi.string().required(),
								description: Joi.string().required(),
							})
						)
						.required(),
				})
			);
			if (!data.pictures) {
				progress.bar_list[3] = false;
				progress.message = "2.2「以照片分享歷程：上傳 DFC 四階段照片」尚未完成";
				return progress;
			} else if (picturesVal) {
				progress.bar_list[3] = true;
			} else {
				progress.bar_list[3] = false;
				progress.message = "2.2「以照片分享歷程：上傳 DFC 四階段照片」尚未完成";
				return progress;
			}

			// 上傳故事資料 - 學習單
			let storyNameVal = validator(data.story_name, Joi.string().required());
			let pdfVal = validator(
				data.pdf_list,
				Joi.array()
					.items(
						Joi.object({
							name: Joi.string().required(),
							url: Joi.string().required(),
						})
					)
					.min(1)
					.required()
			);

			if (storyNameVal && pdfVal) {
				progress.bar_list[4] = true;
			} else {
				progress.bar_list[4] = false;
				progress.message = "2.3「上傳 DFC 挑戰學習單」尚未完成";
				return progress;
			}

			// 上傳故事資料 - 創用CC授權書
			if (typeof data.agree_authorize == "boolean") {
				progress.bar_list[5] = true;
			} else {
				progress.bar_list[5] = false;
			}

			// 上傳故事資料 - 故事影片
			let videoVal = validator(
				data.video,
				Joi.object({
					src: Joi.string()
						// .regex(/^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/)
						.required(),
				}).required()
			);
			if (videoVal) {
				progress.bar_list[6] = true;
			} else {
				progress.bar_list[6] = false;
				progress.message = "2.6「上傳 DFC 挑戰故事影片」尚未完成";
			}

			// 上傳故事資料 - SDGs
			const sdgsVal = validator(
				data.sdgs,
				Joi.array().items(Joi.string().required()).min(1).required()
			);
			if (sdgsVal) {
				progress.bar_list[7] = true;
			} else {
				progress.bar_list[7] = false;
				progress.message = "2.7「勾選符合的 SDGs 項目」尚未完成";
			}

			// 上傳故事資料 - 國際證書資料
			let certificateTeamMembersVal = validator(
				data.team_members,
				Joi.array()
					.items(
						Joi.object({
							wade_giles: Joi.string().required(),
							department_zh: Joi.string().required(),
							department_en: Joi.string().required(),
						})
					)
					.min(1)
					.required()
			);
			let certificateCounselors = validator(
				data.counselors,
				Joi.array()
					.items(
						Joi.object({
							wade_giles: Joi.string().required(),
							department_zh: Joi.string().required(),
							department_en: Joi.string().required(),
						})
					)
					.min(1)
					.required()
			);
			let certificateAddress = validator(
				data.certificate_address,
				Joi.object({
					recipient: Joi.string().required(),
					zip: Joi.string().required(),
					city: Joi.string().required(),
					address: Joi.string().required(),
				}).required()
			);
			if (
				certificateTeamMembersVal &&
				certificateCounselors &&
				certificateAddress
			) {
				progress.bar_list[8] = true;
			} else {
				progress.bar_list[8] = false;
				progress.message = "3.1「填寫國際證書資料」尚未完成";
				return progress;
			}

			//上傳故事資料-填寫問卷
			let questionnaireVal = true;
			for (let member of data.questionnaireStatus) {
				if (!member.status) {
					questionnaireVal = false;
					break;
				}
			}
			if (questionnaireVal) {
				progress.bar_list[9] = true;
			} else {
				progress.bar_list[9] = false;
				progress.message = "3.2「填寫輔導員問卷」尚未完成";
				return progress;
			}

			// 上傳故事資料 - 是否參加
			if (typeof data.is_participate == "boolean") {
				progress.bar_list[10] = true;
			} else {
				progress.bar_list[10] = false;
			}

			return progress;
		},

		// 後台
		async searchBackendAllStories({ commit }, query) {
			await HandleError(async () => {
				let res = await API.GetBackendAllStories(query);
				commit("setStoryList", res.data);
			});
		},
		async getAllStories({}, query) {
			try {
				return (await API.getAllStories(query)).data;
			} catch (e) {
				throw e.response.data;
			}
		},
		async getJudgeStories({ commit }, query) {
			await HandleError(async () => {
				let res = await API.GetJudgeStories(query);
				commit("setStoryList", res.data);
			});
		},
		async getJudgedStories({}) {
			try {
				return (await API.getJudgedStories()).data;
			} catch (e) {
				throw e.response.data;
			}
		},
		async deleteMultiStories({ commit }, data) {
			await HandleError(async () => {
				await API.DeleteMultiStories(data);
			});
		},
		async applyFailed({}, data) {
			await HandleError(async () => {
				await API.ApplyFailed(data);
			});
		},
		async applySuccess({}, data) {
			await HandleError(async () => {
				await API.ApplySuccess(data);
			});
		},
		async uploadYoutbe({}, data) {
			await HandleError(async () => {
				await API.UploadYouTube(data);
			});
		},
		async judgeStory({ dispatch }, { is_submit, data }) {
			await HandleError(async () => {
				await API.JudgeStory(is_submit, data);
			});
		},
	},
};

export default StoryModule;
